<template>
    <div class="wrap">
        <!--上-->
        <div class="silution">
            <!--导航栏-->
            <div class="nav">
                <!-- <p class="logo"><img @click="logo_btn" src="../assets/image/logo1.png" alt=""></p> -->
                <ul>
                    <li @click="silution_btn" class="silution_title">臣麦</li>
                    <li @click="product_btn" class="product_title">Product</li>
                    <li @click="service_btn" class="service_title">Service</li>
                    <li @click="contact_btn" class="contact_title">Contact us</li>
                    <li class="language">
                        <router-link to="/" @click="chinese_btn" :class="is_chinese ? '':'pitch_on'">CN</router-link>
                        <span></span>
                        <router-link to="/english" @click="english_btn" :class="is_english ? '':'pitch_on'">EN
                        </router-link>
                    </li>
                </ul>
            </div>
            <!--silution image-->
            <!-- <img class="img_top img_top_en" src="../assets/image/banner_silution.png" alt=""> -->
            <p class="slogan">It has a global high-quality traffic and senior overseas media delivery team, whose
                business covers application game e-commerce marketing and other fields, and provides professional and
                efficient solutions for enterprise media delivery and traffic marketing</p>
            <img class="img_bottom img_bottom_en" src="../assets/image/banner.png" alt="">
        </div>
        <!--中-->
        <div class="product_service " ref="product">
            <p class="big_title image"><img src="../assets/image/product_service.png" alt=""></p>
            <p class="game_class game_img"><img src="../assets/image/game.png" alt=""></p>
            <ul class="game_content game_content_en">
                <li>
                    <!--<img src="../assets/image/crossy_road.png" alt="">-->
                    <img class="test_img image_animation" src="../assets/image/CrossyRoadNew.png" alt="">
                    <p class="title">Crossy Road</p>
                    <p class="content">Everyday crossing the road is a classic little game that reminds you of your
                        childhood me…<span @click="more_btn(0)">View more</span></p>
                </li>
                <li>
                    <!--<img src="../assets/image/ski_challenge.png" alt="">-->
                    <img class="test_img_center image_animation" src="../assets/image/SkiChallengeNew.png" alt="">
                    <p class="title small_title title_center">Ski Challenge</p>
                    <p class="content small_content content_center">Extremely challenging casual game, characters…<span
                            @click="more_btn(1)">View more</span></p>

                </li>
                <li>
                    <!--<img src="../assets/image/the_ancient_ore.png" alt="">-->
                    <img class="test_img_right image_animation" src="../assets/image/TheAncientOreNew.png" alt="">
                    <p class="title small_title title_right">The Ancient Ore</p>
                    <p class="content small_content content_right">Traditional elimination game, but in the …<span
                            @click="more_btn(2)">View more</span></p>
                </li>
            </ul>

            <div class="game_list">
                <ul>
                    <li>
                        <!--<img src="../assets/image/super_pet.png" alt="">-->
                        <img class="test_image image_animation" src="../assets/image/SuperPetNew.png" alt="">
                        <div class="wrap_div wrap_div_test">
                            <p class="title">Super Pet</p>
                            <p class="content">"Super pet" is a classic three elimination game. Three or more colors of
                                the same colo…</p>
                            <p class="more" @click="more_btn(3)">View more</p>
                        </div>
                    </li>
                    <li>
                        <!--<img src="../assets/image/pilot_training.png" alt="">-->
                        <img class="image_animation" src="../assets/image/PilotTrainingNew.png" alt="">
                        <div class="wrap_div">
                            <p class="title">Pilot Training</p>
                            <p class="content">"Pilot training" is a flying game, users can freely combine their own
                                aircraft appeara…</p>
                            <p class="more" @click="more_btn(4)">View more</p>
                        </div>
                    </li>
                    <li>
                        <!--<img src="../assets/image/small_crocodile.png" alt="">-->
                        <img class="image_animation" src="../assets/image/SmallCrocodileNew.png" alt="">
                        <div class="wrap_div">
                            <p class="title">Small Crocodile</p>
                            <p class="content">At present, AnyRead consistently ranks the top three in download and
                                bestselling list in…</p>
                            <p class="more" @click="more_btn(5)">View more</p>
                        </div>
                    </li>
                </ul>
                <ul>
                    <li>
                        <!--<img src="../assets/image/doodle_jump.png" alt="">-->
                        <img class="image_animation" src="../assets/image/DoodleJumpNew.png" alt="">
                        <div class="wrap_div">
                            <p class="title">Doodle Jump</p>
                            <p class="content">"Graffiti jump" is a fun and skilful game. In the game, players should
                                make graffiti sp…</p>
                            <p class="more" @click="more_btn(6)">View more</p>
                        </div>
                    </li>
                    <li>
                        <!--<img src="../assets/image/wake_up_santa_claus.png" alt="">-->
                        <img class="image_animation" src="../assets/image/WakeUpSantaClausNew.png" alt="">
                        <div class="wrap_div">
                            <p class="title">Wake Up Santa Claus</p>
                            <p class="content">By eliminating the green partition, the snowflakes fall and wake up Santa
                                Claus thr…</p>
                            <p class="more" @click="more_btn(7)">View more</p>
                        </div>
                    </li>
                    <li>
                        <!--<img src="../assets/image/danger.png" alt="">-->
                        <img class="image_animation" src="../assets/image/DangerNew.png" alt="">
                        <div class="wrap_div">
                            <p class="title">Danger</p>
                            <p class="content">"Danger" makes the characters move left and right by moving the mouse
                                left and …</p>
                            <p class="more" @click="more_btn(8)">View more</p>
                        </div>
                    </li>
                </ul>
            </div>

            <!--产品-工具类-->
            <p class="tool tool_en"><img src="../assets/image/tool.png" alt=""></p>
            <div class="tool_wrap tool_wrap_en">
                <div class="left_info">
                    <!--<img src="../assets/image/qtouch.png" alt="">-->
                    <img src="../assets/image/qtouchNew.png" alt="">
                    <p class="title">Qtouch</p>
                    <p class="content">Qtouch is an Android auxiliary control tool software, which integrates various
                        functions in…<span @click="more_btn(9)">View more</span></p>
                </div>
                <ul>
                    <li>
                        <!--<img src="../assets/image/anyRead.png" alt="">-->
                        <img class="image_animation" src="../assets/image/AnyReadNew.png" alt="">
                        <div class="wrap_div">
                            <p class="title">AnyRead</p>
                            <p class="content">At present, AnyRead consistently ranks the top three in download and
                                bestselling list in…</p>
                            <p class="more" @click="more_btn(10)">View more</p>
                        </div>
                    </li>
                    <li class="bottom_li">
                        <!--<img src="../assets/image/SCweather.png" alt="">-->
                        <img class="image_animation" src="../assets/image/SCweatherNew.png" alt="">
                        <div class="wrap_div">
                            <p class="title">SCweather</p>
                            <p class="content">A simple, free weather forecast, user-friendly design, fresh interface,
                                can be customiz…</p>
                            <p class="more" @click="more_btn(11)">View more</p>
                        </div>
                    </li>
                </ul>
            </div>

            <!--服务数据-->
            <p class="service_data_title service_data_title_en" ref="service"><img src="../assets/image/data.png" alt=""></p>
            <ul class="service_data service_data_en">
                <li><img src="../assets/image/instrame.png" alt=""></li>
                <li><img src="../assets/image/facebook.png" alt=""></li>
                <li><img src="../assets/image/google.png" alt=""></li>
                <li><img src="../assets/image/tiktok.png" alt=""></li>
            </ul>
        </div>
        <!--下-->
        <div class="contact_us" ref="contact_us">
            <img class="title" src="../assets/image/contact.png" alt="">
            <p class="email"> 
            <span>联系电话:021 3352 1187</span>
            </p>
            <p class="email">米米<span class="colon">:</span>
            <span>mimi@chenmaish.com</span>
             
            </p>
            <p class="email">
            <span>地址:上海松江區石湖荡镇酬勤路235号1幢302室</span>
            </p>
            <!--<p class="internet_content_provider ">粤ICP备17120737号 Copyright © 2013-2020 Sinozo . All Rights Reserved-->
                <!--.</p>-->
            <!--<p class="bottom internet_content_provider">Silution</p>-->
        </div>
        <!--遮罩-->
        <div v-if="click_more" class="shade">
            <div class="detail">
                <p class="close" @click="close_btn"><img src="../assets/image/close.png" alt=""></p>
                <div class="info">

                    <img :src="detail_info.image" alt="">
                    <div class="content_block">
                        <p class="title">{{detail_info.title}}</p>
                        <p class="content">{{detail_info.content_en}}</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import mixins from "@/assets/silution.js"

    export default {
        name: "chinese_home",
        mixins: [mixins]
    }
</script>

<style scoped>

</style>